module.exports = __webpack_public_path__ + "img/solution-hudxil-system-pic-3.f0c46093.png";